import React from 'react'
import { Routes, Route } from "react-router-dom";

//import CargaCombustibles from '../componentes/view/combustible/CargaConsumoCombustible';
import CargaConsumoCombustible from '../componentes/view/combustible/CargaConsumoCombustible';
import ListadoConsumoCombustible from '../componentes/view/combustible/ListadoConsumoCombustible';

export const CombustibleRoutes = () => {

  return (
    <Routes>            
      <Route path='/cargacombustibles' element={ <CargaConsumoCombustible />}/> 
 <Route path='/listado' element={ <ListadoConsumoCombustible />}/>
    </Routes>
  ) 
}